module.exports = __webpack_public_path__ + "static/media/12UNCTAD1.1cf6c1f9.jpg";